import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Svg from '../modules/Svg';
import Tabs from '../components/tabs/index';
import tabsConfig from '../config/tabsConfigStatistics';

/**
 * Catalogue header component
 * Renders on upcoming sales, sires, vendors and previously sold lots pages
 */
class Statistics extends Component {
    /**
     * Initialize component
     * Takes from view data attributes for displaying sale information
     *
     * @param props
     */
    constructor(props) {
        super(props);
        const dataSet = document.getElementById('root').dataset;

        this.name = dataSet.salename;
        this.company = dataSet.salecompany;
        this.date = dataSet.saledate;
        this.totalLots = dataSet.saletotallots;
        this.activeTab = dataSet.activetab;
    }

    /**
     * Renders catalogue header component
     * Header includes sale information, lots counter, back link to catalogue
     * As child element accepts concrete page (table) content
     *
     * @returns {ReactElement}
     */
    render() {
        return (
            <div>
                <section className="sales__tabHeader">
                    <div className="bsp-backLinkWrp">
                        <a
                            href="/bloodstock/sales/statistics/"
                            className="ui-link ui-link_table bsp-backLink ui-link_marked"
                        >
                            <Svg iconName="left" />
                            <span className="bsp-backLinkText">Back to Sales Statistics</span>
                        </a>
                    </div>

                    <div className="sales__HeaderWrp">
                        <div className="sales__Header">
                            <h1 className="sales__HeaderName">
                                {this.name}
                            </h1>
                            <span className="sales__HeaderCounter">
                                <span className="sales__Counter">
                                    <span
                                        className="sales__CounterText js-sales-lots-total"
                                        data-test-selector="lots_found_header"
                                    >
                                        {this.totalLots || 0}
                                    </span>
                                </span>
                            </span>
                        </div>
                        <div className="sales__Seller">
                            <span className="sales__SellerDate">
                                Dates: <strong>{this.date}</strong>
                            </span>
                            <span className="sales__SellerCompany">
                                Sale Co: <strong>{this.company}</strong>
                            </span>
                        </div>
                    </div>
                    <Tabs options={tabsConfig} activeTab={this.activeTab} />
                </section>
                <section className="sales__content">
                    {this.props.children}
                </section>
            </div>
        );
    }
}

Statistics.propTypes = {
    /**
     * Page content
     * Own prop
     */
    children: PropTypes.object,
};

export default Statistics;



// WEBPACK FOOTER //
// ./src/js/containers/Statistics.js